import { cn } from '@berky/ui'
import { Link } from 'react-router'

/**
 * Wortmarke der Plattform.
 *
 * Das offizielle App-Icon bleibt rein dekorativ: Der Link erklärt sein Ziel
 * bereits vollständig. Das leere `alt` verhindert deshalb eine doppelte
 * Ansage.
 *
 * Es gibt zwei Bausteine:
 *
 * - {@link BrandMark} — nur das dekorative Zeichen.
 * - {@link Brand} — Zeichen und Schriftzug immer zusammen als Link zur
 *   Startseite. Der Navigationsknopf ist ein separates Bedienelement.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <img
      src="/BERKY_Digital_App_Icon.png"
      alt=""
      aria-hidden="true"
      draggable={false}
      className={cn('size-7 shrink-0', className)}
    />
  )
}

/** Zeichen und Schriftzug als gemeinsamer Link zur Startseite. */
export function Brand({
  className,
  onNavigate,
  wordmarkClassName,
}: {
  className?: string
  onNavigate?: () => void
  wordmarkClassName?: string
}) {
  return (
    <Link
      to="/"
      onClick={onNavigate}
      aria-label="Berky Digital – zur Startseite"
      className={cn(
        'flex items-center gap-2.5 rounded-md outline-none',
        'focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring',
        className,
      )}
    >
      <BrandMark />
      <span
        className={cn(
          'flex items-baseline gap-1.5 text-sm whitespace-nowrap',
          wordmarkClassName,
        )}
      >
        <span className="font-semibold tracking-wide text-foreground">BERKY</span>
        <span className="text-muted-foreground">Digital</span>
      </span>
    </Link>
  )
}
